// import { PATTERNS_VALIDATIONS } from "../utils/validationsForFields";

import contentfulRenderOptions from "../../../../utils/contentfulRenderOption";
import rawToReact from "../../../../utils/rawToReact";

interface formMentoriaTalentoAdapterProps {
    form:{
        nodes: [{
            tituloFormulario: string;
            descripcionFormulario: {raw: string} | null;
            titulosFormulario: titulosFormularioProps[];
        }]
    }
}

interface titulosFormularioProps{
    tituloGeneral: string;
    descripcion: {raw: string} | null;
    referenciaFormulario: referenciaFormularioProps[];
}

interface referenciaFormularioProps {
    nombreId: string;
    tipoCampo: string;
    inputPrincipal: string;
    listaSelect: string[];
    textoTerminos?: {raw: string} | null;
    seccion: string;
    placeholder: string;
    mensajeError: string;
    tabOrder?: string | number;
    obligatorio: boolean;
    deshabilitado: boolean;
    fieldMandatory?: string;
}

export function formMentoriaTalentoAdapter(props:formMentoriaTalentoAdapterProps) {
    const data = props.form.nodes[0];
    return {
        mainTitle: data.tituloFormulario,
        mainDescription : data.descripcionFormulario && rawToReact(data.descripcionFormulario.raw,contentfulRenderOptions),
        sections :  data.titulosFormulario?.map((step: titulosFormularioProps) => {
            return {

                title: step.tituloGeneral,
                description: step.descripcion && rawToReact(step.descripcion.raw,contentfulRenderOptions),
                fields: step.referenciaFormulario?.map((field: referenciaFormularioProps) => {
                    return {
                        name: field.nombreId,
                        type: field.tipoCampo,
                        label: field.inputPrincipal,
                        options: field.listaSelect?.map((option) => ({
                            label: option,
                            value: option
                        })),
                        helperText: field.textoTerminos && rawToReact(field.textoTerminos.raw,contentfulRenderOptions),
                        section: field.seccion,
                        placeholder: field.placeholder,
                        msnAdvice: field.mensajeError,
                        tabOrder: field.tabOrder,
                        required: field.obligatorio,
                        disabled: field.deshabilitado,
                        fieldMandatory: field.fieldMandatory,
                        textoTerminos: field.textoTerminos,
                    };
                }), 
            };
        }),
    }
}